import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { fadeIn, fadeInOut, fadeOut } from 'src/app/animations';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
@Component({
    selector: 'app-formulario-jantar',
    templateUrl: './formulario-jantar.component.html',
    styleUrls: ['./formulario-jantar.component.css'],
    animations: [fadeIn, fadeOut, fadeInOut]
})
export class FormularioJantarComponent implements OnInit {
    faSquareXmark = faSquareXmark;
    listaConvidados: any = [];
    convidadoAdulto: number = 0;
    convidadoCrianca: number = 0;
    convidadoBebe: number = 0;
    valorTotal: Number = 118;
    titularAssociado: number = 0;
    parcela: any = 0;
    aceites: boolean = false;
    termschecked: boolean = false;
    loading: boolean = false;
    enabledParcelas!: any[];
    solicitacaoFinalizada: boolean = false;
    dataDeHoje: Date = new Date();
    dataAtualFormatada: any;
    dataLimite: Date = new Date('2024-11-05');
    dataTresParcelas: Date = new Date('2024-09-27');
    dataDuasParcelas: Date = new Date('2024-10-16');
    formInscricaTitular: FormGroup = new FormGroup({
        cpf: new FormControl(null, [Validators.required, ValidaCpf]),
        email: new FormControl(null, [Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')]),
        nome: new FormControl(null, [Validators.required]),
        registro: new FormControl(null, [Validators.required]),
        telefone: new FormControl(null, [Validators.required]),
        titular: new FormControl(false),
    });
    formConvidado: FormGroup = new FormGroup({
        nome: new FormControl(null, [Validators.required]),
        tipoConvidadoId: new FormControl(1, [Validators.required]),
    });
    formData: FormGroup = new FormGroup({
        parcela: new FormControl(null, [Validators.required]),
        titular: new FormControl(false, [Validators.required]),
        listaConvidados: new FormControl(null),
        nome: new FormControl(null, [Validators.required]),
        registro: new FormControl(null, [Validators.required]),
        cpf: new FormControl(null, [Validators.required]),
        telefone: new FormControl(null, [Validators.required]),
        email: new FormControl(null),
        valorTotal: new FormControl(null),
        aceite: new FormControl(null, [Validators.requiredTrue]),
    });
    parcelas: any[] = [
        { desc: "3 parcelas iguais, para confirmações respondidas até 20/08/24. Desconto set/out/nov de 2024", id: 3, maxdate: moment("21/08/2022", "DD/MM/YYYY") },
        { desc: "2 parcelas iguais, para confirmações respondidas até 20/09/24. Desconto out/nov de 2024", id: 2, maxdate: moment("21/09/2022", "DD/MM/YYYY") },
        { desc: "1 parcela, para confirmações respondidas até 20/10/24. Desconto em nov de 2024", id: 1, maxdate: moment("21/10/2024", "DD/MM/YYYY") }
    ];
    titular: any[] = [
        { desc: "Sim", id: 1 },
        { desc: "Não", id: 2 }
    ];
    tipoConvidado: any = [
        { grupo: '1 a 5 anos', value: 1 },
        { grupo: '6 a 10 anos', value: 2 },
        { grupo: 'A partir de 11 anos', value: 3 },
    ];
    constructor(
        private http: HttpClient,
        private toast: ToastrService,
        private datePipe: DatePipe,
    ) {
        this.formConvidado.reset();
        this.formConvidado.updateValueAndValidity();
        this.dataAtualFormatada = this.datePipe.transform(new Date(), 'yyyy/MM/dd');
        this.enabledParcelas = this.parcelas.filter(a => moment() < a.maxdate);
    }
    save() {
        let valorFinal = this.titularAssociado + (this.convidadoCrianca * 59) + (this.convidadoAdulto * 118);
        this.formData.patchValue(this.formInscricaTitular.value);
        this.formData.get('listaConvidados')?.setValue(this.listaConvidados);
        this.formData.get('aceite')?.setValue(this.aceites);
        (valorFinal > 0) ? this.formData.get('parcela')?.setValue(this.parcela) : this.formData.get('parcela')?.setValue(0);
        (valorFinal > 0) ? this.formData.get('valorTotal')?.setValue(valorFinal) : this.formData.get('valorTotal')?.setValue(0);
        this.loading = true;
        const url = `${environment.portalApi}/Aceites/PostJantar`;
        this.http.post(url, this.formData.value, { headers: new HttpHeaders({ 'content-type': 'application/json' }) }).subscribe((res: any) => {
            this.loading = false;
            Swal.fire({
                title: 'Sucesso!',
                text: 'Solicitação realizada com sucesso!',
                icon: 'success',
                showConfirmButton: true
            }).then(() => {
                this.formConvidado.reset();
                this.formInscricaTitular.reset();
                this.formData.reset();
                this.parcela = false;
                this.aceites = false;
                this.solicitacaoFinalizada = true;
            });
        }, (error: any) => {
            this.loading = false;
            if (error.error.Message) {
                Swal.fire({
                    title: error.error.Message.split('||')[0],
                    text: error.error.Message.split('||')[1],
                    icon: 'error',
                    showConfirmButton: true
                }).then(() => { });
            } else {
                Swal.fire({
                    title: 'Erro!',
                    text: 'Solicitação não realizada, favor entrar em contato com a central de atendimento!',
                    icon: 'error',
                    showConfirmButton: true
                }).then(() => { });
            }
        }
        );
    }
    adicionarConvidado() {
        if (this.verificaItemExistente(this.formConvidado.value) == false) {
            this.getCalculo(this.formConvidado.value, 'soma');
            this.listaConvidados.push(this.formConvidado.value);
            this.toast.success('Convidado adicionado com sucesso!');
            this.formConvidado.reset();
        } else {
            this.toast.error("O convidado " + this.formConvidado.value.nome + ' já foi adicionado a sua lista de convidados!');
            this.formConvidado.reset();
        };
    }
    verificaItemExistente(convidado: any): boolean {
        let convidadoEncontrado = false;
        this.listaConvidados.forEach((element: any) => {
            if (convidado.nome == element.nome) {
                convidadoEncontrado = true;
            }
        });
        return convidadoEncontrado;
    }
    redirecionarParaPaginaAtual() {
        window.location.reload();
    }
    removerConvidado(indice: number, convidado: any) {
        this.listaConvidados.splice(indice, 1);
        this.getCalculo(convidado, 'subtracao');
    }
    getTitularValue() {
        if (this.formInscricaTitular.value.titular == true) {
            this.titularAssociado = 0;
            return 1;
        }
        this.titularAssociado = 118;
        return 0;
    }
    getCalculo(a: any, operador: string) {
        switch (a.tipoConvidadoId) {
            case 1:
                operador == 'soma' ?
                    this.convidadoBebe += 1 :
                    this.convidadoBebe -= 1;
                break;
            case 2:
                operador == 'soma' ?
                    this.convidadoCrianca += 1 :
                    this.convidadoCrianca -= 1;
                break;
            case 3:
                operador == 'soma' ?
                    this.convidadoAdulto += 1 :
                    this.convidadoAdulto -= 1;
                break;
        }
    }
    getParcelas(): number {
        let calculo = 0;
        calculo = (this.titularAssociado + (this.convidadoCrianca * 59) + (this.convidadoAdulto * 118));
        setTimeout(() => {
        }, 100)
        return calculo;
    }
    getTotal() {
        this.valorTotal = (this.formData.value.adultos * 118) + (this.formData.value.criancas * 59) + this.titularAssociado;
        return (this.formData.value.adultos * 118) + (this.formData.value.criancas * 59) + this.titularAssociado;
    }
    associadoFc() {
        if (this.formInscricaTitular.get('titular')?.value == false) {
            Swal.fire({
                text: `Caso você não seja associado da APFC, será feita a cobrança integral do jantar, no valor de R$118,00.`,
                icon: 'question',
                showConfirmButton: true,
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: 'Concordar',
                cancelButtonText: 'Cancelar',
            }).then((res) => {
                if (res.value == true) {
                    if (this.formInscricaTitular.get('titular')?.value == true) {
                        this.valorTotal = 118;
                    } else if (this.formInscricaTitular.get('titular')?.value == false && (this.convidadoCrianca > 0 || this.convidadoAdulto == 0)) {
                        this.parcela = 0;
                        const checkboxes = document.querySelectorAll('input[type="radio"]');
                        checkboxes.forEach((checkbox: any) => {
                            checkbox.addEventListener('click', () => {
                                // Desmarca o checkbox clicado
                                checkbox.checked = false;
                            });
                        });
                    }
                } else {
                    this.formInscricaTitular.get('titular')?.setValue(false);
                    this.parcela = 0;
                    const checkboxes = document.querySelectorAll('input[type="radio"]');
                    checkboxes.forEach((checkbox: any) => {
                        checkbox.addEventListener('click', () => {
                            // Desmarca o checkbox clicado
                            checkbox.checked = false;
                        });
                    });
                }
            });
        } else {
            this.formInscricaTitular.get('titular')?.setValue(false);
            this.parcela = 0;
            const checkboxes = document.querySelectorAll('input[type="radio"]');
            checkboxes.forEach((checkbox: any) => {
                checkbox.addEventListener('click', () => {
                    // Desmarca o checkbox clicado
                    checkbox.checked = false;
                });
            });
        }
    }
    ngOnInit(): void {
    }
}
function ValidaCpf(ac: AbstractControl): { [key: string]: boolean } | null {
    let cpf = String(ac.value).replace(/[.-]/g, '');
    let soma = 0;
    let resto: number;
    // if (!ac.touched) {
    //     return null;
    // }
    if (!cpf || cpf === '' || cpf.length > 11 || cpf.length < 11) {
        //if (ac.va)       
        return { invalidCpf: true };
        // else
        // return { invalidCpf: false };
    }
    if (cpf === '00000000000' || cpf === '11111111111' || cpf === '22222222222' ||
        cpf === '33333333333' || cpf === '44444444444' || cpf === '55555555555' ||
        cpf === '66666666666' || cpf === '77777777777' || cpf === '88888888888' ||
        cpf === '99999999999') {
        return { invalidCpf: true };
    }
    for (let i = 1; i <= 9; i++) {
        soma = soma + parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
    }
    resto = (soma * 10) % 11;
    if ((resto === 10) || (resto === 11)) {
        resto = 0;
    }
    if (resto !== parseInt(cpf.substring(9, 10), 10)) {
        return { invalidCpf: true };
    }
    soma = 0;
    for (let i = 1; i <= 10; i++) {
        soma = soma + parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
    }
    resto = (soma * 10) % 11;
    if ((resto === 10) || (resto === 11)) {
        resto = 0;
    }
    if (resto !== parseInt(cpf.substring(10, 11), 10)) {
        return { invalidCpf: true };
    }
    return null;
}